function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 1.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  padding: 0.25rem 0.5rem;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
var TagsContainer = styled.div(_templateObject());
var TagList = styled.div(_templateObject1());
var Tag = styled.span(_templateObject2(), function(props) {
    return props.theme.isDark ? '#1e40af' : '#dbeafe';
}, function(props) {
    return props.theme.isDark ? '#93c5fd' : '#1e40af';
});
export var ProjectTags = function(param) {
    var tags = param.tags;
    if (!tags || tags.length === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(TagsContainer, null, /*#__PURE__*/ React.createElement(TagList, null, tags.map(function(tag, index) {
        return /*#__PURE__*/ React.createElement(Tag, {
            key: index
        }, "#", tag);
    })));
};
export default ProjectTags;
